import React from "react";

interface WaveLoaderProps {
  color?: string; // solid fallback; gradient used by default
  size?: number;
  barCount?: number;
  className?: string;
}

const WaveLoader: React.FC<WaveLoaderProps> = ({
  color = "#B59143",
  size = 72,
  barCount = 6 ,
  className,
}) => {
  const bars = Array.from({ length: barCount });
  const barWidth = Math.max(3, Math.floor(size / (barCount * 2)));
  const gap = Math.max(2, Math.floor(barWidth / 2));
  const totalWidth = barCount * barWidth + (barCount - 1) * gap;

  return (
    <div style={{ width: totalWidth, height: size }} className={className}>
      <div style={{ display: "flex", alignItems: "center", height: "100%", gap }}>
        {bars.map((_, idx) => (
          <span
            key={idx}
            style={{
              display: "inline-block",
              width: barWidth,
              height: Math.max(6, Math.floor(size / 3)),
              background: `linear-gradient(to top, #B59143, #FBD282)`,
              borderRadius: 2,
              transformOrigin: "center bottom",
              animation: `zs-wave 1.1s ${idx * 0.1}s infinite ease-in-out`,
            }}
          />
        ))}
      </div>
      <style>{`
        @keyframes zs-wave {
          0%, 40%, 100% { transform: scaleY(0.4); opacity: 0.8; }
          20% { transform: scaleY(1.0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default WaveLoader;